import React, { Component } from 'react';
import Header from './header.js';
import Tabs from './tabs.js';
import shop from './../shop.js';

class Shop extends Component {
	componentWillMount() {
		shop.init();
	}

	render() {
		return (
			<div id="shop-component">
				<Header />
				<Tabs />
			</div>
		);
	}
}

export default Shop;



// WEBPACK FOOTER //
// ./mobile-core/src/components/shop.js